import { ToastViewComponent } from './toast-view/toast-view.component';
import { VersionComponent } from './version/version.component';

export const containers = [VersionComponent, ToastViewComponent];

export * from './version/version.component';
export * from './toast-view/toast-view.component';
